import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { ISale } from '../../common/types/apiSchema';

export { GET_SALE, ISaleQueryData, ISaleQueryVariables };

const GET_SALE: DocumentNode = gql`
  query Sale($saleId: String!, $affiliate: String, $territory: String) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      editorial {
        weLike
        secondOpinion
      }
    }
  }
`;

interface ISaleQueryData {
  sale: ISale;
}
interface ISaleQueryVariables {
  saleId: string;
  affiliate?: string;
  territory: string;
}
